import {collapseElement, expandElement, mediaQueryBreakpointMD} from "../Utils/Utils";

const MenuOverlay = () => {

	document.querySelectorAll('#menu-overlay .menu-item').forEach((menuItem) => {

		const subMenu = menuItem.querySelector('.sub-menu');
		if(subMenu) {

			if(menuItem.classList.contains('current-menu-parent')) {
				menuItem.classList.add('js-reveal-sub-menu');
			}

			menuItem.querySelector('a:first-child').addEventListener('click', (e) => {

				if(window.innerWidth < mediaQueryBreakpointMD) {

					const menuItem = e.currentTarget.parentNode;
					e.preventDefault();

					if(menuItem.classList.contains('js-reveal-sub-menu') ||	( menuItem.classList.contains('current-menu-parent') && !menuItem.classList.contains('js-conceal-sub-menu'))) {
						collapseElement(subMenu, () => {
							menuItem.classList.remove('js-reveal-sub-menu');
							menuItem.classList.remove('js-revealing-sub-menu');
							menuItem.classList.add('js-conceal-sub-menu');
						});
					}
					else {
						menuItem.classList.add('js-revealing-sub-menu');
						expandElement(subMenu, () => {
							menuItem.classList.add('js-reveal-sub-menu');
							menuItem.classList.remove('js-revealing-sub-menu');
						});
					}
				}
			});
		}
	});
};

export default MenuOverlay;